import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import MenuItem from '@material-ui/core/MenuItem';

import { red, blue } from '@material-ui/core/colors';

import { getResumeDay } from '../../store/transactions/transactionsActions';
import useTypedSelector from '../../hooks/useTypedSelector';
import { formatBrl } from '../../utils';

export default function TransactionsResumeMonth() {
  const {
    resumeDay,
    isLoading,
  } = useTypedSelector(({ transactionsState }) => ({
    resumeDay: transactionsState.resumeDay,
    isLoading: transactionsState.loadingResume,
  }));

  const year = useRef(new Date().getFullYear());

  const [ selectedMonth, setSelectedMonth ] = useState( moment().format('MM') );
  const [ selectedYear, setSelectedYear ] = useState( moment().format('YYYY') );
  const dispatch = useDispatch();

  useEffect(() => {
      dispatch( getResumeDay(`${selectedYear}-${selectedMonth}`) );
  }, [ dispatch, selectedMonth, selectedYear ]);

  return (
    <Box p={2}>
      <TextField
        select
        label='Mês'
        value={selectedMonth}
        onChange={e => setSelectedMonth(e.target.value)}
        style={{ marginBottom: 32, marginRight: 16 }}
      >
        <MenuItem value='01' children='Janeiro' />
        <MenuItem value='02' children='Fevereiro' />
        <MenuItem value='03' children='Março' />
        <MenuItem value='04' children='Abril' />
        <MenuItem value='05' children='Maio' />
        <MenuItem value='06' children='Junho' />
        <MenuItem value='07' children='Julho' />
        <MenuItem value='08' children='Agosto' />
        <MenuItem value='09' children='Setembro' />
        <MenuItem value='10' children='Outubro' />
        <MenuItem value='11' children='Novembro' />
        <MenuItem value='12' children='Dezembro' />
      </TextField>
      <TextField
        select
        label='Ano'
        value={selectedYear}
        onChange={e => setSelectedYear(e.target.value)}
      >
        {[...new Array(10)].map((_, i) => (
          <MenuItem
            key={i}
            value={year.current - i}
            children={(year.current - i).toString()}
          />
        ))}
      </TextField>
      {isLoading && (
        <LinearProgress />
      )}
      {resumeDay && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Typography style={{ color: blue[500] }} variant='h6' align='center'>
              Receitas
            </Typography>
            <Table>
              <TableBody>
                {resumeDay.incomes.map((item: any, i: number) => (
                  <TableRow key={i}>
                    <TableCell>{item.category}</TableCell>
                    <TableCell><b>{formatBrl(item.value)}</b></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Typography style={{ color: red[500] }} variant='h6' align='center'>
              Despesas
            </Typography>
            <Table>
              <TableBody>
                {resumeDay.expenses.map((item: any, i: number) => (
                  <TableRow key={i}>
                    <TableCell>{item.category}</TableCell>
                    <TableCell><b>{formatBrl(item.value)}</b></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}
